import DatalakeSidebar from './DatalakeSidebar';
import { authedApiFetch } from '../../utils/Api';
import { Outlet, useOutletContext, useLoaderData } from 'react-router';
import { Box } from '@mui/material';

export async function loader({ params }) {
	const [connections, services] = await Promise.all([
		authedApiFetch({
			endpoint: `/tenants/${params.tenantId}/datalake/connections`,
			method: 'GET',
		}),
		authedApiFetch({
			endpoint: `/tenants/${params.tenantId}/datalake/services`,
			method: 'GET',
		}),
	]);

	// Wrap in a safe promise that never fails so the UI doesn't break
	let jobDataPromise = Promise.resolve({ job_found: false, job_runs: [] });

	try {
		// Try to fetch job data, but prepare to handle errors
		jobDataPromise = authedApiFetch({
			endpoint: `/tenants/${params.tenantId}/data_job_runs`,
			method: 'GET',
		}).catch((error) => {
			console.log(
				'Databricks connection error - continuing without job data:',
				error.message
			);
			return { job_found: false, job_runs: [] };
		});
	} catch (error) {
		// This catch is redundant but adds an extra safety layer
		console.log('Failed to initiate job data fetch:', error);
	}

	return { connections, services, jobDataPromise };
}

export async function action({ request, params }) {
	const requestJson = await request.json();
	const { name, serviceId, environment, ...settings } = requestJson;

	const connection = await authedApiFetch({
		method: 'POST',
		endpoint: `/tenants/${params.tenantId}/datalake/connections`,
		payload: {
			connection: {
				name: name,
				settings: settings,
				environment: environment,
				service_id: serviceId,
			},
		},
	});

	return connection;
}

const Datalake = () => {
	const { tenant, user } = useOutletContext();
	const { connections, services, jobDataPromise } = useLoaderData();

	return (
		<div
			style={{
				height: 'calc(100vh - 122px)',
				boxSizing: 'border-box',
				display: 'flex',
				paddingTop: '12px',
			}}
		>
			<DatalakeSidebar
				connections={connections}
				services={services}
				jobDataPromise={jobDataPromise}
				tenant={tenant}
				user={user}
			/>
			<Box
				component='main'
				boxSizing='border-box'
				height='100%'
				width='calc(100vw - 300px)'
				sx={{ p: 3, overflowY: 'auto' }}
				display='flex'
				flexDirection='column'
				rowGap='16px'
			>
				<Outlet context={{ connections, services, user }} />
			</Box>
		</div>
	);
};

export default Datalake;
